var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice",class:_vm.appendedLevel},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./admin/src/js/components/AcNotice.vue